import { FC, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import { Providers } from "./components/providers";
import { Router } from "./routes/Router";
import "./App.css";
import { initGA } from "./util/analytics";
import { AnalyticsTracker } from "@/components/common/AnalyticsTracker";

export const App: FC = () => {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Providers>
      <BrowserRouter>
        <AnalyticsTracker />
        <Router />
      </BrowserRouter>
    </Providers>
  );
};
